import { DirectedGraph } from "directed-graph-typed";
import { categoriesToHashTable } from './CategoriesArrayToHashTable';


/**
 * - Transforms the categories array to an hash table
 * - Adds every category key to a graph
 * - Sets up the relationships (edges) between each category and their parent (parent is root if no `parentCategoryKey` is specified)
 * - Attaches parentless categories to root
 * 
 * @param {Array<Category>} categoriesArray: The array of all the categories
 * @returns {Graph<String, Int>}: A graph with root element with key 'root', representing the relationships between categories and their parents
 */
export const makeCategoriesGraph = (categoriesArray) => {

    const categoryIDToObjectMapper = categoriesToHashTable(categoriesArray)
    
    // REARRANGE CATEGORIES HERE
    const categoriesGraph = new DirectedGraph()
    categoriesGraph.addVertex('root', 0)

    categoriesArray.forEach((category) => {
        categoriesGraph.addVertex(category.categoryKey, category.pos)
    })
    

    // Bind categories to their parents
    categoriesGraph
        .filter((_, graphItemKey) => { // isIncluded?
            return categoryIDToObjectMapper[graphItemKey]?.hasOwnProperty('parentCategoryKey')
        })
        .filter((graphItem) => { // isIncluded?
            return categoryIDToObjectMapper[categoryIDToObjectMapper[graphItem[0]].parentCategoryKey]
        })
        .forEach((graphItem) => {
            categoriesGraph.addEdge(
                /*sourceKey:*/categoryIDToObjectMapper[graphItem[0]].parentCategoryKey, 
                /*destKey:*/ graphItem[0], 
                /*weight:*/ 1
            )
        })
        
    // Bind parentless categories to root
    categoriesGraph.forEach(
        (_, graphItemKey) => {
            // Handle top level categories (except root):
            if (graphItemKey !== 'root' && categoriesGraph.incomingEdgesOf(categoriesGraph.getVertex(graphItemKey)).length <= 0) {
                categoriesGraph.addEdge(
                    /*sourceKey:*/'root', 
                    /*destKey:*/ graphItemKey, 
                    /*weight:*/ 1
                )
            }
        }
    )


    return categoriesGraph
}
